export const collaborationPrivateRoutesConstants = {
  root: {
    path: "/r/app/collab",
    href: () => `/r/app/collab`
  },
  todos: {
    path: "/r/app/collab/todos",
    href: (projectId: string) => `/r/app/collab/todos?project=${projectId}`
  },
  brainstorming: {
    path: "/r/app/collab/brainstorming",
    href: (projectId: string) =>
      `/r/app/collab/brainstorming?project=${projectId}`
  },
  ee_roadmap: {
    path: "/r/app/collab/ee-roadmap",
    href: () => "/r/app/collab/ee-roadmap"
  }
} as const;
